export function sortedNotes(entry) {
    return [...(entry.notes || [])].sort((first, second) => {
        const firstTime = first.createdAt
            ? new Date(first.createdAt).getTime()
            : 0;
        const secondTime = second.createdAt
            ? new Date(second.createdAt).getTime()
            : 0;
        return firstTime - secondTime;
    });
}

export function formatNoteDate(value) {
    if (!value) return "-";
    return new Date(value).toLocaleString(
        [Meteor.settings.public.locale],
        Meteor.settings.public.datestamp,
    );
}

export function noteDirection(status) {
    if (status === "contacted") return "out";
    if (status === "in_review") return "in";
    if (status === "closed") return "closed";
    return "unknown";
}
